import { createBrowserRouter } from "react-router-dom";
import { AuthGuard } from "@/app/AuthGuard";
import { RootErrorBoundary } from "@/app/RootErrorBoundary";
import { AuthPage } from "@/features/auth/AuthPage";
import { AppLayout } from "@/layouts/AppLayout";
import { AccountPage } from "@/pages/AccountPage";
import { ApiKeysPage } from "@/pages/ApiKeysPage";
import { CheckoutCancelPage } from "@/pages/CheckoutCancelPage";
import { CheckoutSuccessPage } from "@/pages/CheckoutSuccessPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { HomePage } from "@/pages/HomePage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { SubscriptionPage } from "@/pages/SubscriptionPage";

export const router = createBrowserRouter([
  {
    errorElement: <RootErrorBoundary />,
    children: [
      { path: "/login", element: <AuthPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
      {
        element: <AuthGuard />,
        children: [
          { path: "/billing/success", element: <CheckoutSuccessPage /> },
          { path: "/billing/cancel", element: <CheckoutCancelPage /> },
          {
            element: <AppLayout />,
            children: [
              { index: true, element: <HomePage /> },
              { path: "/api-keys", element: <ApiKeysPage /> },
              { path: "/account", element: <AccountPage /> },
              { path: "/subscription", element: <SubscriptionPage /> },
            ],
          },
        ],
      },
    ],
  },
]);
